module.exports = __webpack_public_path__ + "static/media/Icons_Idle_04_Trophy.b2a0b33c.svg";